var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill inventory-scan-container"},[(_vm.qrCodeBase64)?_c('div',{staticClass:"qr-code"},[_c('img',{attrs:{"src":'data:image/png;base64,' + _vm.qrCodeBase64,"alt":"二维码"}})]):_vm._e(),_c('div',{staticClass:"instruction"},[_vm._v("\n        用扫码枪扫描以开始盘库\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }